
export const getLocalizedAttribute = (object, key, language) => {
  if (
      object.localizedAttributes &&
      object.localizedAttributes[language]
  ) {
    return object.localizedAttributes[language][key];
  } else {
    return null;
  }
};

export const localizedAttribute = getLocalizedAttribute;